var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allcontens"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"account_content"},[_c('img',{staticClass:"account_img",attrs:{"src":require("@/assets/agreement/404-1.svg"),"alt":"404"}}),_c('span',{staticClass:"account_span"},[_vm._v("请通过官方二维码扫码进入")])])])])
}]

export { render, staticRenderFns }